import React from 'react'; 
import PropTypes from "prop-types"
import styled from 'styled-components';
import PostCard from './postCard';

const RelatedPostTitle =styled.div`
  font-family: var(--title-font);
  color: #292929;
  font-size: 35px;
  font-weight: 600;
  position: relative;
  margin-bottom: 30px;
  text-align: center;
`;
const RelatedPostItems = styled.div`
	margin-bottom: 15px;
  	display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 10px;
    @media (max-width: 850px){
    grid-template-columns: 1fr;
    row-gap: 15px;
    column-gap: 0;

}
`;

const RelatedPost = ({title, posts}) => {


const elements = posts.map(({ node }, idx) => (
    <PostCard
        key={node.fields.slug}
        node={node}
     />
  ));



  return (
    <>
  	   <RelatedPostTitle>{title}</RelatedPostTitle>
  	   <RelatedPostItems>{elements}</RelatedPostItems>
    </>
  );

}

RelatedPost.propTypes = {
  node: PropTypes.object.isRequired,
  title: PropTypes.string,
};

export default RelatedPost;
